/** A visitor's calls for a share link. The link code goes in the body, never the URL. */

import { apiCall } from '../api.ts';
import type { Branding } from '../portal/portal-api.ts';
import type { PageQuery } from '../portal/use-read-only-page.ts';
import type {
  Catalogue,
  CompareSetting,
  DocumentKind,
  Page,
  RangeSetting,
  WidgetResult,
} from '../reports/reports-api.ts';

export type OpenedShare =
  | { locked: true }
  | {
      locked: false;
      share: { name: string; allow_range_change: boolean };
      document: {
        name: string;
        kind: DocumentKind;
        settings: { range?: RangeSetting; compare?: CompareSetting };
        theme: Record<string, unknown>;
      };
      pages: Page[];
      client: { name: string };
      branding: Branding;
      catalogue: Catalogue;
    };

const post = <T>(path: string, body: Record<string, unknown>) =>
  apiCall<T>(`/public/share/${path}`, { method: 'POST', body: JSON.stringify(body) });

/** The link code from a /s/<code> address, or null on any other page. */
export function shareTokenFromUrl(): string | null {
  const match = /^\/s\/([A-Za-z0-9_-]{10,100})\/?$/.exec(window.location.pathname);
  return match ? (match[1] as string) : null;
}

export const publicShareApi = {
  open: (token: string, pass: string | null) =>
    post<OpenedShare>('open', { token, ...(pass ? { pass } : {}) }),
  unlock: (token: string, password: string) =>
    post<{ pass: string }>('unlock', { token, password }).then((data) => data.pass),
  query: (token: string, pass: string | null, input: PageQuery) =>
    post<{ results: WidgetResult[]; range: { from: string; to: string } }>('query', {
      token,
      ...(pass ? { pass } : {}),
      page: input.page,
      range: input.range,
    }),
};
